export default "__VITE_ASSET__U_BTw6CB__"